import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'
import { selectCommitmentStatusesByProgramType } from 'legacy/lut/features/partner360/commitment'
import {
  CommitmentReminderAction,
  ICommitmentReminder,
} from 'legacy/lut/services/partner360/commitment/models/ICommitmentReminder'
import { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { CommitmentReminder } from 'partner360/components/commitmentReminder/CommitmentReminder'
import { PlanReviewConfirmation } from 'partner360/components/commitmentReminder/components/planReviewConfirmation/PlanReviewConfirmation'

import styles from './ReviewPlan.module.scss'

export const ReviewPlan = () => {
  const commitmentInfo = useSelector(selectCommitmentStatusesByProgramType)
  const [isShowReviewPlanConfirmation, setIsShowReviewPlanConfirmation] = useState(false)

  const reviewReminder = useMemo(() => {
    const parsed = parseJson<ICommitmentReminder[]>(commitmentInfo?.Reminders || '') ?? []

    return parsed.find((el) => el.Action === CommitmentReminderAction.ReviewPlanAction)
  }, [commitmentInfo?.Reminders])

  const reviewPlan = useCallback(async () => {
    setIsShowReviewPlanConfirmation(true)
  }, [])

  return (
    <div className={styles.root}>
      {reviewReminder && commitmentInfo?.IsReviewRequired ? (
        <CommitmentReminder reminder={reviewReminder} onPlanReviewClick={reviewPlan} />
      ) : null}

      <PlanReviewConfirmation
        onClose={() => setIsShowReviewPlanConfirmation(false)}
        isVisible={isShowReviewPlanConfirmation}
      />
    </div>
  )
}
